import type { ChatAbnormalType } from "./chatAbnormalReporter";

export interface ChatStreamErrorInfo {
  code?: string | number;
  status?: number;
  errorOrigin?: "server" | "transport" | "protocol";
}

/** 依据错误产生的位置分类，不能把后端通用 -1 或“卡住”当成用户断线。 */
export function isChatTransportFailure(info?: ChatStreamErrorInfo): boolean {
  if (info?.errorOrigin === "server" || info?.errorOrigin === "protocol") return false;
  return info?.errorOrigin === "transport" || Number(info?.status) >= 400 ||
    ["STREAM_INCOMPLETE", "AGENT_STREAM_INCOMPLETE", "CLIENT_TIMEOUT"].includes(String(info?.code));
}

export function classifyChatStreamFailure(
  message: string,
  info: ChatStreamErrorInfo | undefined,
  receivedContent: boolean,
  online: boolean,
): ChatAbnormalType | undefined {
  if (info?.errorOrigin === "protocol") return "CLIENT_PARSE_ERROR";
  if (info?.errorOrigin === "server") {
    // 已知业务拒绝不作为客户端技术异常重复上报。
    return String(info.code) === "-10020" ? undefined : "SSE_ERROR";
  }
  if (Number(info?.status) >= 400) return "HTTP_ERROR";
  if (!isChatTransportFailure(info)) return "SSE_ERROR";
  if (String(info?.code) === "CLIENT_TIMEOUT" || /超时|timeout/i.test(message)) {
    return receivedContent ? "STREAM_TIMEOUT" : "FIRST_TOKEN_TIMEOUT";
  }
  if (["STREAM_INCOMPLETE", "AGENT_STREAM_INCOMPLETE"].includes(String(info?.code))) {
    return "PARTIAL_RESPONSE";
  }
  if (!online) return "NETWORK_ERROR";
  return receivedContent ? "PARTIAL_RESPONSE" : "SSE_DISCONNECT";
}
